export default "__VITE_ASSET__C$MwyKB9__"